<template>
  <div>
    <NavButton chevron :toggled="showMenu" class="hidden md:flex" @click="toggleMenu">
      Our services
    </NavButton>
    <NavMenu :show="showMenu" :showing-all-services="showAllServices" @hide="toggleMenu(false)">
      <div class="md:hidden border-t-2 pt-ds-sm mb-ds-xxs mt-ds-sm text-black opacity-50 w-full">Services</div>
      <NavMenuItem
        image="nav_cars-us"
        url="/us/car-shipping"
        qa-tag="nav-our-services-cars"
        @click="$emit('track', 'our-services', 'cars')"
      >
        Car shipping
      </NavMenuItem>
      <NavMenuItem
        image="nav_truck-us"
        url="/us/truck-shipping"
        qa-tag="nav-our-services-truck"
        @click="$emit('track', 'our-services', 'truck')"
      >
        Truck shipping
      </NavMenuItem>
      <NavMenuItem
        image="nav_motorbike-us"
        :url="getAbsoluteUrl('send-goods/vehicle_move')"
        qa-tag="nav-our-services-motorbike"
        @click="$emit('track', 'our-services', 'motorbike')"
      >
        Motorcycle shipping
      </NavMenuItem>
      <NavMenuItem
        image="nav_furniture"
        url="/us/furniture-enquiry-form"
        qa-tag="nav-our-services-furniture"
        @click="$emit('track', 'our-services', 'furniture')"
      >
        Furniture delivery
      </NavMenuItem>
      <NavMenuItem
        image="nav_removals"
        url="/us/home-removals-enquiry"
        qa-tag="nav-our-services-removals"
        @click="$emit('track', 'our-services', 'removals')"
      >
        Home removals
      </NavMenuItem>
      <!-- mobile-only -->
      <NavLoginButton
        services
        redirect-url="https://www.anyvan.us/login-with-credentials"
        qa-tag="nav-our-services-login"
        class="mt-auto"
      />
      <!-- end mobile-only -->
    </NavMenu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import NavOurServicesBase from "~/components/base/navOurServices"

export default defineComponent({
  name: "NavOurServicesUs",
  extends: NavOurServicesBase,
  methods: {
    getAbsoluteUrl(path: string): string {
      return `${this.$config.public.v4Host.replace("com", this.$i18n.locale)}/${path}`
    }
  }
})
</script>
